import {getWithToken, postWithToken, putWithToken} from "../../../api/network";

export async function GetSavedFilters(userId, userHasUnderwriteManagerRole) {
  const url = `/api/dashboard/filters?userId=${userId}`;
  let response = {};

  try {
    response = await getWithToken(url);
  } catch (e) {
    console.error('Error during GetSavedFilters request ...', e);
  }

  if (response.ok) {
    const data = await response.json();

    return data.map(filter => {
      return {
        ...filter,
        rules: JSON.parse(filter.rules),
        filter: typeof filter.filter === 'string' ? JSON.parse(filter.filter) : filter.filter,
        canDelete: filter.userId === userId || (userHasUnderwriteManagerRole && filter.viewType === 0),
      }
    });
  }

  console.log(response.status, response.statusText);
  return [];
}

export async function PostSavedFilter(filter) {
  const url = `/api/dashboard/filters`;
  const response = await postWithToken(url, filter);
  const data = await response.json();

  console.log(data);

  return data;
}

export async function PutSavedFilter(filter, requestUserId) {
  const url = `/api/dashboard/filters?requestUserId=${requestUserId}`;
  return  await putWithToken(url, filter);
}
